import FilterConfig, {
    SearchTypes,
    Types,
} from "../../components/FilterMaker/FilterConfig";

export const PendingApprovalFilterConfig: FilterConfig = {
    table: "brokerActionList",
    tabKey: "status",
    url: "",
    statusCountUrl: "",
    pageSize: 10,
    topSectionButtons: [],
    filters: [
        {
            column: "search",
            id: "search1",
            type: Types.search,
            label: "Search",
            searchType: SearchTypes.like,
            options: [
                { tag: "Name", value: "name" },
                { tag: "Health Id", value: "tpaId" },
                { tag: "Employee Id", value: "employeeId" },
            ],
        },
    ],
};
